import React, { FC, PropsWithChildren } from 'react'
import styles from './VisuallyHidden.module.scss'

export const VisuallyHidden: FC<PropsWithChildren> = ({ children }) => {
  return <span className={styles.visuallyHidden}>{children}</span>
}
